const getters = {
  visitedViews: state => state.tagesView.visitedViews,
  cachedViews: state => state.tagesView.cachedViews,

  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  topbarRouters: state => state.permission.topbarRouters,
  defaultRoutes: state => state.permission.defaultRoutes,
  sidebarRouters: state => state.permission.sidebarRouters
}

export default getters
